import { useMemo } from 'react';
import {
  HUNT_ACTIVITY,
  OUTDOOR_RECREATION_ACTIVITY,
  species,
  activitiesTypeMap,
} from '../marketplace-custom-config';

const useWhatsIncluded = ({ currentPackage, activityData, intl }) => {
  const features = useMemo(() => {
    if (!currentPackage) return [];

    const { activity } = currentPackage;
    const result = [];

    // Handle Hunting Activity
    if (activity === HUNT_ACTIVITY) {
      const { species: gameSpecies, methods } = currentPackage;
      const { amenities } = activityData || {};

      // Species/Game Types
      if (gameSpecies && gameSpecies.length > 0) {
        const speciesItems = gameSpecies.map(gameKey => {
          const speciesData = species?.hunt[gameKey];
          const iconVariant = speciesData?.iconVariant;
          const label = gameKey === 'other' && gameKey.name ? gameKey.name : speciesData?.label;

          return {
            iconVariant,
            label,
          };
        });

        result.push({
          heading: intl.formatMessage({ id: 'ListingPage.gameTypesTitle' }),
          items: speciesItems,
        });
      }

      // Hunting Methods
      const amenityItems = [];

      const { allowsArchery, allowsFirearms } = methods || {};
      if (allowsArchery || allowsFirearms) {
        if (allowsFirearms) {
          amenityItems.push({
            iconVariant: 'Rifle',
            label: intl.formatMessage({ id: 'ListingPage.huntMotFirearms' }),
          });
        }

        if (allowsArchery) {
          amenityItems.push({
            iconVariant: 'Archery',
            label: intl.formatMessage({ id: 'ListingPage.huntMotArchery' }),
          });
        }
      }

      // Hunt Amenities
      const {
        hasTreeStands,
        hasGroundBlinds,
        hasGameCameras,
        hasGameFeeders,
        treeStands,
        groundBlinds,
        gameCameras,
        gameFeeders,
      } = amenities || {};

      if (hasTreeStands) {
        amenityItems.push({
          iconVariant: 'TreeStand',
          label: intl.formatMessage({ id: 'ListingPage.TreeStands' }, { quantity: treeStands }),
        });
      }

      if (hasGroundBlinds) {
        amenityItems.push({
          iconVariant: 'GroundBlind',
          label: intl.formatMessage({ id: 'ListingPage.GroundBlinds' }, { quantity: groundBlinds }),
        });
      }

      if (hasGameCameras) {
        amenityItems.push({
          iconVariant: 'GameCam',
          label: intl.formatMessage({ id: 'ListingPage.GameCameras' }, { quantity: gameCameras }),
        });
      }

      if (hasGameFeeders) {
        amenityItems.push({
          iconVariant: 'GameFeeder',
          label: intl.formatMessage({ id: 'ListingPage.GameFeeders' }, { quantity: gameFeeders }),
        });
      }

      if (amenityItems.length > 0) {
        result.push({
          heading: intl.formatMessage({ id: 'ListingPage.huntAmenities' }),
          items: amenityItems,
        });
      }
    }

    // Handle Outdoor Recreation Activity
    if (activity === OUTDOOR_RECREATION_ACTIVITY) {
      const { activities = [] } = currentPackage || {};

      if (activities.length > 0) {
        const activitiesMap = {};
        activitiesTypeMap.forEach(activityType => {
          activitiesMap[activityType.key] = activityType.label;
        });

        const activityItems = activities.map(activityKey => {
          const iconVariant = activitiesTypeMap.find(
            activityType => activityType.key === activityKey
          )?.iconVariant;

          return {
            iconVariant,
            label: activitiesMap[activityKey] || activityKey,
          };
        });

        result.push({
          heading: intl.formatMessage({ id: 'ListingPage.outdoorActivitiesTitle' }),
          items: activityItems,
        });
      }
    }

    return result;
  }, [currentPackage, activityData, intl]);

  return { features };
};

export default useWhatsIncluded;
